import { render, staticRenderFns } from "./WhitePublicLayout.vue?vue&type=template&id=952e2bb6&scoped=true"
import script from "./WhitePublicLayout.vue?vue&type=script&lang=js"
export * from "./WhitePublicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952e2bb6",
  null
  
)

export default component.exports